function updateReduxUtil (instance, updates) {
  if (!instance) {
    return
  }
  return {
    ...instance,
    changed: {
      ...instance.changed,
      ...updates
    },
    error: null,
    validation: null,
    status: null
  }
}

export default updateReduxUtil
